import BatchActionIcon from 'app/shared-components/TableControls/BatchActionIcon'
import {
    useTableActionsContext,
} from 'app/shared-components/TableActionsContext'

type Props = {
    isMenuItem?: boolean
}

const CsvUploadButton = ({
    isMenuItem = false,
}: Readonly<Props>) => {
    const {
        setBatchActionData,
    } = useTableActionsContext()

    const handleClick = () => {
        setBatchActionData(true)
    }

    return (
        <BatchActionIcon
            isMenuItem={isMenuItem}
            onClick={handleClick}
            title="Bulk Create"
        />
    )
}

export default CsvUploadButton
